import React from "react";
import { SectionContainer, SectionLabel, SectionHeading, SectionLead } from "./SectionPrimitives";

const STEPS = [
  {
    n: "01",
    title: "Quellen analysieren",
    desc: "Wir prüfen DMS-Export, IMS, OEM-Feeds, Bildquellen und Drittanbieter. Definieren Datenverantwortung pro Feld.",
    output: "Quellen-Audit · Mapping-Matrix",
  },
  {
    n: "02",
    title: "Bestand erfassen",
    desc: "Automatisierte Importpipeline mit Versionierung, Diff-Tracking und Snapshot-Logik pro Fahrzeug.",
    output: "Daily Inventory Snapshot",
  },
  {
    n: "03",
    title: "Datenqualität herstellen",
    desc: "Validierung, Pflichtfeld-Logik, Konsistenz-Checks. Score pro Fahrzeug und pro Standort.",
    output: "Quality-Score · Disapproval-Report",
  },
  {
    n: "04",
    title: "Inhalte anreichern",
    desc: "Anreicherung aus unserer Fahrzeug-Datenbank: Ausstattung, Verbrauch, technische Daten, vergleichbare Modelle.",
    output: "Enriched Vehicle Record",
  },
  {
    n: "05",
    title: "Ausspielung Feed + SEO",
    desc: "Stündliche Feed-Synchronisation für Google Vehicle Ads + Generierung indexierbarer Fahrzeug-Landingpages.",
    output: "Live Feed · SEO Pages",
  },
];

export default function Prozess() {
  return (
    <SectionContainer id="prozess">
      <div className="max-w-3xl">
        <SectionLabel number="/ 03" label="So funktioniert es" />
        <SectionHeading>Ein definierter Prozess. Kein Tooling-Bastel-Stack.</SectionHeading>
        <SectionLead>
          Vom ersten Audit bis zur Live-Ausspielung in 14–21 Tagen. Standardisierte Schritte,
          eindeutige Verantwortungen, prüfbare Ergebnisse.
        </SectionLead>
      </div>

      <div className="mt-16 relative">
        <div className="absolute left-0 right-0 top-12 h-px bg-slate-200 hidden lg:block" aria-hidden />
        <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-slate-200 border border-slate-200 rounded-lg overflow-hidden">
          {STEPS.map((s) => (
            <li key={s.n} data-testid={`prozess-step-${s.n}`} className="bg-white p-6 sm:p-7 relative">
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center justify-center size-7 rounded-md bg-slate-900 text-white font-mono text-[11px]">
                  {s.n}
                </span>
                <span className="size-2 rounded-full bg-cyan-500" />
              </div>
              <h3 className="mt-5 font-display font-semibold text-slate-900 text-[17px]">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              <div className="mt-5 pt-4 border-t border-slate-100">
                <p className="label-mono text-slate-400">Output</p>
                <p className="mt-1 font-mono text-[12px] text-slate-700">{s.output}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </SectionContainer>
  );
}
